import { makeObservable, observable, runInAction } from 'mobx';
import {
    IApplicationConfigs,
    TenantManagementApi,
} from '@servicetitan/marketing-tenant-management-api';
import { inject, injectable } from '@servicetitan/react-ioc';
import { LoadStatus } from '../enums/load-status';

@injectable()
export class AppStore {
    @observable appConfigs!: IApplicationConfigs;
    @observable appLoadStatus = LoadStatus.None;

    constructor(
        @inject(TenantManagementApi) private readonly tenantManagementApi: TenantManagementApi,
    ) {
        makeObservable(this);
    }

    init = async () => {
        runInAction(() => {
            this.appLoadStatus = LoadStatus.Loading;
        });

        try {
            const { data: appConfigs } = await this.tenantManagementApi.configGET();

            runInAction(() => {
                this.appConfigs = appConfigs;
                this.appLoadStatus = LoadStatus.Ok;
            });
        } catch {
            runInAction(() => {
                this.appLoadStatus = LoadStatus.Error;
            });
        }
    };
}
